import React, { Suspense, useEffect, useLayoutEffect } from "react";
import "./App.css";
import Nav from "./Nav";
import Footer from "./Footer";
import About from "./pages/About";
import Artikler from "./pages/Artikler";
import CCM from "./pages/CCM";
import DocEngine from "./pages/DocEngine";
import Migrator from "./pages/Migrator";
import Contact from "./pages/forms/Contact";
import Customers from "./pages/Customers";
import Partners from "./pages/Partners";
import { HelmetProvider } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import {
  Routes,
  Route,
  BrowserRouter as Router,
  useLocation,
} from "react-router-dom";

import Main from "./pages/Main";
import { Toaster } from "react-hot-toast";

import i18next from "i18next";
import Tilgjengelighetsdirektivet from "./pages/articles/Tilgjengelighetsdirektivet";
import ErDinBedriftKlar from "./pages/articles/ErDinBedriftKlar";
import GjorDokumenteneDineTilgjengelige from "./pages/articles/GjorDokumenteneDineTilgjengelige";
import KommunikasjonSomByggerTillit from "./pages/articles/KommunikasjonSomByggerTillit";
import LinkNordicPartnership from "./pages/articles/LinkNordicPartnership";
import CCMBankForsikring from "./pages/articles/CCMBankForsikring";
import NavCollaboration from "./pages/articles/NavCollaboration";
import { ReactTagManager } from 'react-gtm-ts';
import CookieConsentBanner from "./components/CookieConsent";
import NewsletterPopup from "./components/NewsletterPopup";
import GamlePDFerTilgjengelige from "./pages/articles/GamlePDFerTilgjengelige";
import GjensidigeXPER from "./pages/articles/GjensidigeXPER";
import DigitaleKommunikasjonstrender from "./pages/articles/DigitaleKommunikasjonstrender";
import OffentligSektor from "./pages/articles/OffentligSektor";
import FemStegUniversellUtforming from "./pages/articles/FemStegUniversellUtforming";
import HelseInformasjon from "./pages/articles/HelseInformasjon";
import EAAKonkurranseevne from "./pages/articles/EAAKonkurranseevne";
import CustomerDocsTelecom from "./pages/articles/CustomerDocsTelecom";
import IntervjuBjarneSorum from "./pages/articles/IntervjuBjarneSorum";
import TransportReiseliv from "./pages/articles/TransportReiseliv";
import HvaKosterDetALaVaere from "./pages/articles/HvaKosterDetALaVaere";
import StudentOpplevelse from "./pages/articles/StudentOpplevelse";
import IntervjuPaalVinland from "./pages/articles/IntervjuPaalVinland";
import HvorforHasterDetNa from "./pages/articles/HvorforHasterDetNa";
import KlareDokumenterTryggereBomiljoer from "./pages/articles/KlareDokumenterTryggereBomiljoer";
import PraktiskVeikartPDF from "./pages/articles/PraktiskVeikartPDF";
import IntervjuSuparna from "./pages/articles/IntervjuSuparna";
import RegningenKundeopplevelse from "./pages/articles/RegningenKundeopplevelse";
import DokumenterDelAvStrategien2026 from "./pages/articles/DokumenterDelAvStrategien2026";
import IntervjuPavel from "./pages/articles/IntervjuPavel";
import IntervjuJensUgland from "./pages/articles/IntervjuJensUgland";

const ScrollWrapper = ({ children }) => {
  const location = useLocation();

  useLayoutEffect(() => {
    // Scroll to the top of the page when the route changes
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [location.pathname]);

  return children;
};

function App() {

  ReactTagManager.init({
    code: 'GTM-5MTB63XR', // GTM Code
    debug: false, // debug mode (default false)
    performance: false, // starts GTM only after user interaction (improve initial page load)
  });

  
  useTranslation();


  return (
    <Suspense fallback="loading">
      <HelmetProvider>
        <div className="App">
          <Toaster />
          <CookieConsentBanner />
          <NewsletterPopup />

          <Nav />

          <main>
            <ScrollWrapper>
              <Routes>
                <Route path="/" element={<Main />} />
                <Route path="/om-xper" element={<About />} />
                <Route path="/artikler" element={<Artikler />} />
                <Route
                  path="artikler/fem-steg-universell-utforming-pdf"
                  element={<FemStegUniversellUtforming />}
                />
                <Route
                  path="artikler/helseinformasjon-alle-kan-forsta"
                  element={<HelseInformasjon />}
                />
                <Route
                  path="artikler/offentlig-sektor-tilgjengelige-dokumenter"
                  element={<OffentligSektor />}
                />
                <Route
                  path="artikler/tilgjengelighetsdirektivet"
                  element={<Tilgjengelighetsdirektivet />}
                />
                <Route
                  path="artikler/er-din-bedrift-klar"
                  element={<ErDinBedriftKlar />}
                />
                <Route
                  path="artikler/gjor-dokumentene-dine-tilgjengelige"
                  element={<GjorDokumenteneDineTilgjengelige />}
                />
                <Route
                  path="artikler/kommunikasjon-som-bygger-tillit"
                  element={<KommunikasjonSomByggerTillit />}
                />
                <Route
                  path="artikler/linknordic-partnership"
                  element={<LinkNordicPartnership />}
                />
                <Route
                  path="artikler/ccm-for-bank-og-forsikring"
                  element={<CCMBankForsikring />}
                />
                <Route
                  path="artikler/nav-samarbeid"
                  element={<NavCollaboration />}
                />
                <Route
                  path="artikler/gamle-pdf-er-tilgjengelige"
                  element={<GamlePDFerTilgjengelige />}
                />
                <Route
                  path="artikler/gjensidige-xper-samarbeid"
                  element={<GjensidigeXPER />}
                />
                <Route
                  path="artikler/digitale-kommunikasjonstrender-2025"
                  element={<DigitaleKommunikasjonstrender />}
                />
                <Route
                  path="artikler/eaa-konkurranseevne-bransjer"
                  element={<EAAKonkurranseevne />}
                />
                <Route
                  path="artikler/kundedokumenter-kundeservice-telekom"
                  element={<CustomerDocsTelecom />}
                />
                <Route
                  path="artikler/intervju-bjarne-sorum"
                  element={<IntervjuBjarneSorum />}
                />
                <Route
                  path="artikler/trygghet-pa-reisen-tydelig-kommunikasjon"
                  element={<TransportReiseliv />}
                />
                <Route
                  path="artikler/hva-koster-det-a-la-vaere"
                  element={<HvaKosterDetALaVaere />}
                />
                <Route
                  path="artikler/tydelig-kommunikasjon-styrker-studentopplevelsen"
                  element={<StudentOpplevelse />}
                />
                <Route
                  path="artikler/intervju-paal-vinland"
                  element={<IntervjuPaalVinland />}
                />
                <Route
                  path="artikler/hvorfor-haster-det-na"
                  element={<HvorforHasterDetNa />}
                />
                <Route
                  path="artikler/klare-dokumenter-skaper-tryggere-bomiljoer"
                  element={<KlareDokumenterTryggereBomiljoer />}
                />
                <Route
                  path="artikler/praktisk-veikart-pdf"
                  element={<PraktiskVeikartPDF />}
                />
                <Route
                  path="artikler/intervju-suparna"
                  element={<IntervjuSuparna />}
                />
                <Route
                  path="artikler/2026-dokumenter-del-av-strategien"
                  element={<DokumenterDelAvStrategien2026 />}
                />
                <Route
                  path="artikler/intervju-pavel-pajer"
                  element={<IntervjuPavel />}
                />
                <Route
                  path="artikler/intervju-jens-ugland"
                  element={<IntervjuJensUgland />}
                />
                <Route
                  path="artikler/nar-regningen-blir-del-av-kundeopplevelsen"
                  element={<RegningenKundeopplevelse />}
                />
                <Route path="/docengine" element={<DocEngine />} />
                <Route path="/ccm" element={<CCM />} />
                <Route path="/migrator" element={<Migrator />} />
                <Route
                  path="/skjema/kontakt-oss"
                  element={<Contact subject="kontakt-oss" />}
                />
                <Route
                  path="/skjema/book-demo"
                  element={<Contact subject="book-demo" />}
                />
                <Route
                  path="/skjema/snakk-med-ekspert"
                  element={<Contact subject="snakk-med-ekspert" />}
                />
                 <Route
                  path="/skjema/test-dokument-tilgjengelighet"
                  element={<Contact subject="test-dokument-tilgjengelighet" />}
                />
                <Route path="/kunder" element={<Customers />} />

                <Route path="/partnere" element={<Partners />} />
              </Routes>
            </ScrollWrapper>
          </main>
         
          <Footer />
        </div>
      </HelmetProvider>
    </Suspense>
  );
}

export default App;
